/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_DescInputs */

const en_directory_submit_review_desc = /** @type {(inputs: Directory_Submit_Review_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your draft is saved. Choose how it enters the directory — free review, or a paid plan to publish faster with dofollow.`)
};

const zh_directory_submit_review_desc = /** @type {(inputs: Directory_Submit_Review_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿已保存。选择它进入目录的方式 — 免费审核，或付费方案更快发布并获得 dofollow。`)
};

/**
* | output |
* | --- |
* | "Your draft is saved. Choose how it enters the directory — free review, or a paid plan to publish faster with dofollow." |
*
* @param {Directory_Submit_Review_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_desc = /** @type {((inputs?: Directory_Submit_Review_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_desc(inputs)
	return zh_directory_submit_review_desc(inputs)
});
export { directory_submit_review_desc as "directory.submit.review.desc" }